import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunkMiddleware from 'redux-thunk';

import { 
    loggerMiddleware,
    monitorReducerEnhancer
 } from "./redux/index";

import { 
    formReducer,
    navigationReducer,
    globalStyleReducer,
    queryStringReducer
} from './redux/index';

import { inputHelper } from "./utils/index";

let middlewares = [
    thunkMiddleware
]

if (process.env.NODE_ENV !== 'production') {
    middlewares = [...middlewares, loggerMiddleware]
}


const middlewareEnhancer = applyMiddleware(...middlewares);

const enhancers = [
    middlewareEnhancer, 
    monitorReducerEnhancer
]
const composedEnhancers = compose(...enhancers)

//Get from session storage
const persistedState = sessionStorage.getItem('userData')
                        ? 
                        {
                            formReducer: {
                                formData: JSON.parse(sessionStorage.getItem('userData'))
                            }
                        }
                        :
                        {}

export default createStore(
    combineReducers({
        formReducer: formReducer,
        navigationReducer: navigationReducer,
        globalStyleReducer: globalStyleReducer,
        queryStringReducer: queryStringReducer
    }),
    persistedState,
    composedEnhancers
)